import { render, staticRenderFns } from "./headerMain.vue?vue&type=template&id=d8297674&scoped=true&"
import script from "./headerMain.vue?vue&type=script&lang=js&"
export * from "./headerMain.vue?vue&type=script&lang=js&"
import style0 from "./headerMain.vue?vue&type=style&index=0&id=d8297674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8297674",
  null
  
)

export default component.exports